
/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import * as statusActions from 'actions/statusActions';
import * as userActions from 'actions/userActions';
import * as workOrderActions from 'actions/workOrderActions';
import * as techInventoryActions from 'actions/techInventoryActions';
import { Tabs, Tab } from 'material-ui/Tabs';
import TechInfo from 'techComponents/TechInfo';
import SearchSelectMd from 'techComponents/SearchSelectMd';
import AssignedServiceOrders from 'workOrderComponents/AssignedServiceOrders';
import Loading from 'components/layout/Loading';
import TechInventory from 'equipmentComponents/TechInventory';
import Footer from 'containers/Footer';
import { Link } from 'react-router-dom';
import SearchIcon from 'material-ui/svg-icons/action/search';

export class TechSearchPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.findTech = this
            .findTech
            .bind(this);

        this.onTechIdChange = this
            .onTechIdChange
            .bind(this);

        this.updateRecentSearches = this
            .updateRecentSearches
            .bind(this);

        this.recentSearchChanged = this
            .recentSearchChanged
            .bind(this);

        this.recentSearchOptions = [];
    }

    componentWillReceiveProps(nextProps) {

        const {
            techData,
            workOrderActions,
            techInventoryActions,
            user
        } = nextProps;

        if (techData.getIn(['techSearch', 'topMatch'])) {

            const techUserId = techData.getIn(['techSearch', 'topMatch']);
            const currentUserId = user.get('userId');
            const statusLoading = techData.getIn(['techs', techUserId, 'statusLoading']);
            const statusWaiting = techData.getIn(['techs', techUserId, 'statusWaiting']);
            const statusLoadingFinished = techData.getIn(['techs', techUserId, 'statusLoadingFinished']);

            const workOrderLoading = techData.getIn(['techs', techUserId, 'workOrderLoading']);
            const workOrderLoadingFinished = techData.getIn(['techs', techUserId, 'workOrderLoadingFinished']);

            const inventoryLoading = techData.getIn(['techs', techUserId, 'inventory', 'loading']);
            const inventoryLoadingFinished = techData.getIn(['techs', techUserId, 'inventory', 'loadingFinished']);

            if (!statusLoading && !statusWaiting && !statusLoadingFinished) {
                const channels = [techUserId, currentUserId];
                statusActions.getTechStatusStarted({
                    techStatusChange: {
                        userId: techUserId,
                        techStatusWorkOrder: {
                            workOrderNumber: null,
                            arrivalTime: null
                        },
                        techStatus: "GetStatus"
                    },
                    channels: channels
                }, techUserId);
            }

            if (!workOrderLoading && !workOrderLoadingFinished) {
                userActions.setTechSearchProperty(null);

                workOrderActions.workOrderGetTechRouteStarted({ userId: techUserId, isSelf: false });
            }

            const shouldLoadInventory = !inventoryLoading && !inventoryLoadingFinished;

            if (techUserId && shouldLoadInventory) {

                techInventoryActions.getTechInventoryStarted({
                    isSelf: false
                }, techUserId);
            }
        }

        this.updateRecentSearches();
    }

    updateRecentSearches() {
        const { techData, user } = this.props;
        const currentUserId = user.get('userId');

        if (techData.getIn(['techSearch', 'techSearchResults'])) {
            const recentSearchs = techData
                .getIn(['techSearch', 'techSearchResults'])
                .keySeq()
                .toArray();
            this.recentSearchOptions = [];
            recentSearchs.forEach(function (userId) {
                if (userId && userId !== currentUserId) {

                    const techInfo = techData.getIn(['techs', userId]);

                    this
                        .recentSearchOptions
                        .push({
                            userId: userId,
                            techId: techInfo.getIn(['info', 'techId'])
                        });
                }
            }, this);
        }

    }

    recentSearchChanged(event, index, value) {
        const { userActions } = this.props;
        userActions.setTechSearchTopMatch(value);
    }

    findTech(event) {
        const { techData, userActions } = this.props;
        event.preventDefault();
        userActions.getTechInfoStarted(techData.getIn(['techSearch', 'searchCriteria']));
    }

    onTechIdChange(techId) {
        const { userActions } = this.props;
        userActions.setTechSearchProperty(techId);
    }

    buildRecentSearches() {
        if (this.recentSearchOptions.length > 0) {
            return (<SearchSelectMd
                options={this.recentSearchOptions}
                useNullableFirstItem={true}
                labelText="Recent Searches"
                value={null}
                onChange={this.recentSearchChanged}
                style={{
                    color: "black"
                }} />);
        }
    }

    generateContent() {
        const {
            techData,
            statusActions,
            workOrder,
            history,
            user,
            workOrderActions,
            techInventoryActions
        } = this.props;

        const searchLoading = techData.getIn(['techSearch', 'searchLoading']);

        if (searchLoading) {
            return (<Loading message="Loading..." isLoading={true} />);
        }

        const currentUserId = user.get('userId');
        const techUserId = techData.getIn(['techSearch', 'topMatch']);
        const thisTech = techData.getIn(['techs', techUserId]);
        const searchError = techData.getIn(['techSearch', 'error']);

        let defaultMessage;
        if (searchError === "ajax error 404") {
            defaultMessage = "No Tech Found";
        } else if (searchError) {
            defaultMessage = searchError;
        }

        if (!techUserId || !thisTech) {
            return (
                <h6>
                    {defaultMessage}
                </h6>
            );
        }

        if (techUserId === currentUserId) {
            return (
                <h5 style={{
                    paddingTop: '15px'
                }}>
                    If you are looking for your route, please click &nbsp;
                    <Link to="my-route">
                        here
                    </Link>.
                </h5>
            );
        }

        if (techUserId) {

            const inventory = techData.getIn(['techs', techUserId, 'inventory']);
            return (
                <div>

                    <Tabs>

                        <Tab label={`Tech: ${thisTech.getIn(['info', 'techId'])}`}>
                            <div>
                                <TechInfo
                                    key={'TechInfo'}
                                    tech={thisTech}
                                    currentUserId={currentUserId}
                                    onRefreshStatus={statusActions.getTechStatusStarted} />
                            </div>
                        </Tab>

                        <Tab label="Route">
                            <div
                                style={{
                                    minHeight: '150px',
                                    paddingTop: '10px'
                                }}>
                                <AssignedServiceOrders
                                    key={'techroute'}
                                    userId={techUserId}
                                    history={history}
                                    isSelf={false}
                                    workOrder={workOrder}
                                    assignedServiceOrders={techData.getIn(['techs', techUserId, 'assignedServiceOrders'])}
                                    workOrderDetails={workOrder.get('workOrderDetails')}
                                    workOrderLoading={techData.getIn(['techs', techUserId, 'workOrderLoading'])}
                                    routeRefreshed={techData.getIn(['techs', techUserId, 'routeLoadedTime'])}
                                    workOrderActions={workOrderActions}
                                    refreshAction={workOrderActions.workOrderGetTechRouteStarted} />
                            </div>
                        </Tab>

                        <Tab label="Inventory">
                            <div
                                style={{
                                    minHeight: '150px',
                                    paddingTop: '10px'
                                }}>
                                <TechInventory
                                    inventory={inventory}
                                    isSelf={false}
                                    userId={techUserId}
                                    getTechInventoryStarted={techInventoryActions.getTechInventoryStarted} />
                            </div>
                        </Tab>

                    </Tabs>

                </div>
            );

        }
        return null;
    }

    render() {

        const { user, techData } = this.props;

        const isFieldAdmin = user.get('isFieldAdmin');

        if (!isFieldAdmin) {
            return (
                <h5>You do not have access to this page. Please create a ticket and request
                    field admin access.</h5>
            );
        }

        this.updateRecentSearches();

        return (
            <div>
                <div>
                    <h5 style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: '2em', justifyContent: 'center' }}>
                        <SearchIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                        Tech Search
                    </h5>
                    <form className="searchForm" onSubmit={this.findTech}>
                        <div className="row">
                            <span className="col s8">
                                <TextField
                                    className="wow-fst-input-container"
                                    value={techData.getIn(['techSearch', 'searchCriteria']) ? techData.getIn(['techSearch', 'searchCriteria']) : ''}
                                    hintText="Tech Id"
                                    fullWidth={true}
                                    onChange={(e) => this.onTechIdChange(e.target.value)} />
                            </span>
                            <span className="col s4">
                                <RaisedButton
                                    disabled={!techData.getIn(['techSearch', 'searchCriteria'])}
                                    label="Search"
                                    type="submit"
                                    primary={true}
                                    style={{
                                        margin: 12
                                    }} />
                            </span>
                        </div>
                    </form>
                </div>
                <div className="row neg-margin-top">
                    <span className="col s12">
                        {this.buildRecentSearches()}
                    </span>
                </div>
                <div>
                    {this.generateContent()}
                </div>

                <Footer />
            </div>
        );
    }
}

TechSearchPage.propTypes = {
    user: PropTypes.object,
    techData: PropTypes.object,
    statusActions: PropTypes.object,
    userActions: PropTypes.object,
    workOrder: PropTypes.object,
    workOrderActions: PropTypes.object,
    history: PropTypes.object,
    techInventoryActions: PropTypes.object
};

function mapStateToProps(state) {
    return {
        workOrder: state.get('workOrder'),
        user: state.get('user'),
        techData: state.get('techData')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        workOrderActions: bindActionCreators(workOrderActions, dispatch),
        techInventoryActions: bindActionCreators(techInventoryActions, dispatch),
        statusActions: bindActionCreators(statusActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        push: bindActionCreators(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TechSearchPage);


// WEBPACK FOOTER //
// ./src/containers/pages/TechSearchPage.js